<script setup lang="ts">
// stores
const authStore = useAuthStore()

// composables
const theme = useTheme()

// computed
const { isAuthenticated, user } = storeToRefs(authStore)
const userTheme = computed(() => user.value?.Settings?.theme || 'phoenix')

// lifecycle
watch(userTheme, (nVal) => {
  theme.global.name.value = nVal
})
</script>

<template>
  <v-app>
    <LayoutCartDrawer v-if="isAuthenticated" />

    <LayoutAppBar v-if="isAuthenticated" />

    <LayoutNavDrawer v-if="isAuthenticated" />

    <LayoutContent />

    <LayoutAppFooter v-if="!isAuthenticated" />

    <AppSnackbar />

    <AppSystemState :authenticated="isAuthenticated" />

    <AppFileUploader />

    <AppPdfViewer />

    <AppTour v-if="isAuthenticated" />
  </v-app>
</template>

<style lang="sass">
html
  background: url("/src/assets/background.webp") no-repeat center center fixed
  -webkit-background-size: cover
  -moz-background-size: cover
  -o-background-size: cover
  background-size: cover
  background-color: rgb(var(--v-theme-background-variant),0.3)

#app
  .v-application
    background-color: unset

.v-input__details
  margin-bottom: 0px !important

input[type=file]
  position: absolute
  left: -99999px

.fill-width
  width: 100%

$sizes: 50, 75, 100, 125, 150, 175, 200, 250, 300, 350, 400, 450, 500, 600, 700
@each $size in $sizes
  .min-#{$size}
    min-width: #{$size}px
  .max-#{$size}
    max-width: #{$size}px

.pre
  white-space: pre
.pre-wrap
  white-space: pre-wrap
</style>
